import Swal from 'sweetalert2';
import type { SweetAlertOptions } from 'sweetalert2';
import {
  swalCancelButtonColor,
  swalConfirmButtonColor,
} from '~/constants/theme';

export function useSwal() {
  const warnModal = Swal.mixin({
    icon: 'warning',
    confirmButtonColor: swalConfirmButtonColor,
    cancelButtonColor: swalCancelButtonColor,
    showCancelButton: true,
  });

  const toast = Swal.mixin({
    position: 'bottom-end',
    toast: true,
    timer: 5000,
    showConfirmButton: false,
    showCloseButton: true,
  });

  function errorToast(options: SweetAlertOptions) {
    return toast.fire({
      timer: undefined,
      position: 'top',
      icon: 'error',
      ...options,
    });
  }

  function successToast(options: SweetAlertOptions) {
    return toast.fire({
      position: 'top',
      icon: 'success',
      ...options,
    });
  }

  return {
    warnModal,
    toast,
    errorToast,
    successToast,
  };
}
